import type { SubEntryType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  MenuModalButton,
  MenuModalButtonIcon,
  MenuModalButtonText,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { useCallback } from "react"

import {
  ActivityIcon,
  ActivityName,
} from "src/components/Activity"

interface Props {
  subEntryType: SubEntryType;
  onClick: (subEntryType: SubEntryType) => void;
}

export function SubEntryTypeSelector(props: Props) {
  const {
    subEntryType, onClick,
  } = props

  const handleOnClick: MouseEventHandler<HTMLButtonElement> =
    useCallback(
      () => {
        onClick(subEntryType)
      },
      [
        subEntryType,
        onClick,
      ],
    )

  const normalizedSubEntryType = subEntryType.replace(
    /[\s_]+/g,
    "-",
  )

  return (
    <MenuModalButton
      onClick={handleOnClick}
      id={`sub-entry-${normalizedSubEntryType}`}
    >
      <MenuModalButtonIcon>
        <ActivityIcon activityType={subEntryType} />
      </MenuModalButtonIcon>
      <MenuModalButtonText>
        <ActivityName activityType={subEntryType} />
      </MenuModalButtonText>
    </MenuModalButton>
  )
}
